var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "gmp-modal" }, [
    _c(
      "div",
      {
        staticClass:
          "my-account__modal-box no-scroll-modal my-account__modal-box--usage-detail"
      },
      [
        _c("div", { staticClass: "modal-usage-pick-a-view__header" }, [
          _c("span", { staticClass: "modal-usage-pick-a-view__title" }, [
            _vm._v("Graph Layers")
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass:
                "close bill-pay__close gds-button gds-button-circle gds-secondary",
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  return _vm.closeModal()
                }
              }
            },
            [
              _c("svg", { staticClass: "gds-icon close-icon" }, [
                _c("use", {
                  attrs: {
                    "xlink:href":
                      "/wp-content/themes/gmptwentynineteen/assets/symbol-defs.svg#gds-icon-close-small"
                  }
                })
              ])
            ]
          )
        ]),
        _vm._v(" "),
        _c("FocusLock", [
          _c("div", { staticClass: "modal-usage-pick-a-view__modal-body" }, [
            _c(
              "div",
              { staticClass: "modal-usage-pick-a-view__options-body" },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "modal-usage-pick-a-view__options-body__button-options"
                  },
                  _vm._l(_vm.layers, function(layer) {
                    return _c(
                      "div",
                      {
                        key: layer.name,
                        ref: "layers",
                        refInFor: true,
                        staticClass:
                          "modal-usage-pick-a-view__nav-select-button gds-button gds-button-outline gds-compact",
                        on: {
                          click: function($event) {
                            return _vm.updateSelected(layer)
                          }
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "usage-detail__usage-graph-modal-circle"
                          },
                          [
                            _c("svg", { staticClass: "gds-icon" }, [
                              _c("use", {
                                attrs: {
                                  "xlink:href":
                                    "/wp-content/themes/gmptwentynineteen/assets/symbol-defs.svg#gds-icon-check"
                                }
                              })
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass:
                              "modal-usage-pick-a-view__nav-select-button__label"
                          },
                          [_vm._v(_vm._s(layer.label))]
                        )
                      ]
                    )
                  }),
                  0
                )
              ]
            )
          ])
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }